import { render } from "./CampaignDashboardChart.vue?vue&type=template&id=1b30f972"
import script from "./CampaignDashboardChart.vue?vue&type=script&lang=js"
export * from "./CampaignDashboardChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__